import AOS from "aos";
import "aos/dist/aos.css";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router";
import { toast } from "react-toastify";
import api, { shareUrl } from "../../../../../../api/api";
import { Create_lesson_logo } from "../../../../../../assets/images/images";
import { useAuth } from "../../../../../../features/auth/AuthContext";
import { changeScrollPopup } from "../../../../../../utils/utlis";
import FloatingAIButton from "../../../../../../components/FloatingAIButton/FloatingAIButton";
import {
  setDrawerState,
  setIsWebAllowed,
  setQueryMetaData,
  setAgentData,
  setInitialProjectId,
} from "../../../../../../state/reducers/chatDrawerReducers";
import CourseDetailsHeader from "./CourseDetailsHeader";
import CourseTab from "./CourseTab";
import { resetdeleteLesson } from "../../../../../../state/actions/deleteLessonAction";
import { resetdeleteAssignment } from "../../../../../../state/actions/deleteAssignmentAction";
import AddTeachers from "./AddTeachers";
import AlertConfirmationPopup from "../../../../../../components/AlertConformationPopup/AlertConformationPopup";
import { getCourseTeachers } from "../../../../../../state/actions/getCourseTeachersAction";
import { getActivityLogs } from "../../../../../../state/actions/getActivityLogsAction";
import {
  createLessons,
  resetcreateLessonsStatus,
} from "../../../../../../state/actions/createLessonsAction";
import UploadFiles from "./Modals/UploadFiles";
import AddLessonModal from "./Modals/AddLessonModal";
import BackButton from "../../../../../../components/BackButton/BackButton";

const MIN_CREATE_LESSON_COUNT = 1;
const MAX_CREATE_LESSON_COUNT = 10;
const DEFAULT_CREATE_LESSON_COUNT = 1;

const SESSION_KEYS_TO_CLEAR_ON_COURSE_VIEW = [
  "Assingment_Id",
  "Rubric_id",
  "lesson_name",
  "lesson_formState",
  "lesson_storySetup",
  "lesson_generationType",
  "globleOnChangeData",
  "RandomNumber",
  "GlobleSaveData",
  "lessonDetails",
  "roomId",
  "assignmentDurationCount",
  "skipLesson",
  "DisableLessonTab",
  "newlesson",
];



// top of CreateCourse.jsx, outside the component
const makeLinkRow = () => ({
  id:
    typeof crypto !== "undefined" && crypto.randomUUID
      ? crypto.randomUUID()
      : `link-${Date.now()}-${Math.random().toString(36).slice(2)}`,
  value: "",
  error: "",
  loading: false,
  saved: false,
  locked: false,
  taskId: "",
  pollUrl: "",
  youtubeUrl: "",
  rawUrl: "",
  type: "",
});

const TeacherViewCourseDetails = () => {
  const dispatch = useDispatch();
  const chatDrawerState = useSelector((state) => state?.ChatDrawerState);
  const createLessonsState = useSelector((state) => state?.createLessons);
  const navigate = useNavigate();
  const location = useLocation();

  // Clear lesson/assignment-related session data when entering course details (runs once on mount)
  useEffect(() => {
    SESSION_KEYS_TO_CLEAR_ON_COURSE_VIEW.forEach((key) =>
      sessionStorage.removeItem(key),
    );
  }, []);

  // condition if teacher paste the invite link for student into another teacher account
  useEffect(() => {
    // Don't redirect when returning from View Lesson (back button)
    if (location?.state === "after submission") return;
    // Allow navigation from universal search without redirecting
    if (
      !location?.state ||
      (!location?.state?.from && !location?.state?.course)
    ) {
      navigate("/", { replace: true });
    }
  }, [location.state, navigate]);

  const [inputValue, setInputValue] = useState("");
  const globalState = useSelector((state) => state.globalState);
  const [course, setCourse] = useState(location.state?.course || {}); // default to Student if no role is passed

  const [totalLessons, setTotalLessons] = useState(0);
  const [totalAssignments, setTotalAssignments] = useState(0);
  const [totalStudent, setTotalStudent] = useState(0);

  const [links, setLinks] = useState([makeLinkRow()]);
  const [invitationSuccessfull, setinvitationSuccessfull] = useState(false);
  const { token } = useAuth();
  const { id } = useParams();
  const isLowerSchoolEnabled = globalState.enabled_modules?.includes("lowerSchool") &&  course?.to_grade !== null && typeof course?.to_grade === 'object'
    && +Object.keys(course?.to_grade)[0] <= 5
  const teacher_id =
    location.state?.teacher_id ??
    globalState.teacher_details?.data?.teacher_id ??
    "";

  const [loading, setLoading] = useState(false);
  const adminRole = globalState?.role === "Admin";
  const backToCourses = location.state?.backToCourses || false;

  const [showDropdown, setShowDropdown] = useState(false); // State to control visibility
  const [skipForNow, setSkipForNow] = useState(false);

  const toggleDropdown = () => {
    onShare(getPlatform.SHARE, false);
    setShowDropdown(!showDropdown); // Toggle the visibility state
    changeScrollPopup("auto", "view-course-details-share-form");
  };

  const [showinvite, setShowinvite] = useState(false); // State to control visibility
  const modalRef = useRef(null);
  const [showCreateLessonCountPopup, setShowCreateLessonCountPopup] = useState(
    false,
  );
  const [createLessonCount, setCreateLessonCount] = useState(
    DEFAULT_CREATE_LESSON_COUNT,
  );
  const [createLessonStep, setCreateLessonStep] = useState(1);
  const [enableClick, setEnableClick] = useState(false);
  const createLessonModalRef = useRef(null);
  const [awaitingCreateLessonsNav, setAwaitingCreateLessonsNav] = useState(
    false,
  );
  const [lessonsRefreshKey, setLessonsRefreshKey] = useState(0);
  const createLessonsPostRef = useRef({
    course: null,
    teacher_id: "",
    lesson_count: 1,
    course_id: null,
  });
  const mobileModalRef = useRef(null);

  // Event listener to detect clicks outside the modal
  const handleClickOutside = (event) => {
    const insideDesktop = modalRef.current?.contains(event.target);
    const insideMobile = mobileModalRef.current?.contains(event.target);
    if (!insideDesktop && !insideMobile) {
      setShowinvite(false);
    }
    if (
      showCreateLessonCountPopup &&
      createLessonModalRef.current &&
      !createLessonModalRef.current.contains(event.target)
    ) {
      setShowCreateLessonCountPopup(false);
      changeScrollPopup("auto", "view-course-details-share-form");
    }
  };

  const toggleinvite = () => {
    setInputValue(""); // reset input value
    setFormErrors({
      students: "",
    });
    setStudents([]); // reset students array
    setShowinvite(!showinvite); // Toggle the visibility state
    changeScrollPopup("auto", "view-course-details-share-form");
  };

  const onEditCourseClick = () => {
    navigate(`/course/${course.course_id}/edit`, {
      state: { course, teacher_id },
    });
  };

  const onInvitedStudents = () => {
    navigate(`/invited-students/${id}`, { state: { teacher_id, course } });
  };

  const openCreateLessonCountPopup = () => {
    setCreateLessonCount(DEFAULT_CREATE_LESSON_COUNT);
    setCreateLessonStep(1);
    setShowCreateLessonCountPopup(true);
  };


  const youtubeUrls = links
    .filter((r) => r.saved && (r.youtubeUrl || r.rawUrl))
    .map((r) => r.youtubeUrl || r.rawUrl);

  const onNavigateNewLesson = (lesson) => {
    const key = `previewLessonData`;
    const data = { course, teacher_id, lesson };

    sessionStorage.setItem(key, JSON.stringify(data));
    sessionStorage.setItem("newlesson", true);

    navigate(
      `/NewLessons?course_id=${course.course_id}&teacher_id=${teacher_id}&lesson_id=${lesson.lesson_id}`,
    );
  };

  const closeCreateLessonCountPopup = () => {
    setShowCreateLessonCountPopup(false);
    setCreateLessonStep(1);
    setEnableClick(false);
    setSkipForNow(false);
    changeScrollPopup("auto", "view-course-details-share-form");
  };

  const incrementCreateLessonCount = () => {
    setCreateLessonCount((c) => Math.min(MAX_CREATE_LESSON_COUNT, c + 1));
  };

  const decrementCreateLessonCount = () => {
    setCreateLessonCount((c) => Math.max(MIN_CREATE_LESSON_COUNT, c - 1));
  };

  const confirmCreateLessonNavigation = (isSkipForNow = false, files = [], repoFiles = []) => {
    if (!course?.course_id) {
      toast.error("Course not found", {
        position: "top-center",
      });
      return Promise.reject(new Error("Course not found"));
    }
    if (teacher_id === "") {
      toast.error("Teacher id is required", {
        position: "top-center",
      });
      return Promise.reject(new Error("Teacher id is required"));
    }
    const teacherNum = Number(teacher_id);
    if (!Number.isFinite(teacherNum) || teacherNum <= 0) {
      toast.error("Invalid teacher id", {
        position: "top-center",
      });
      return Promise.reject(new Error("Invalid teacher id"));
    }

    const payload = new FormData();
    payload.append("teacher", String(teacherNum));
    payload.append("status", "1");
    payload.append("is_personalize", "true");
    payload.append("lesson_count", String(createLessonCount));
    payload.append("lower_school", isLowerSchoolEnabled);



    (course?.course_file_urls || []).forEach((fileUrl) => {
      if (fileUrl) {
        payload.append("file_url", String(fileUrl));
      }
    });
    if (files?.length > 0) {
      files.forEach((file) => {
        payload.append("lesson_file", file);
      });
    }

    if (!isSkipForNow) {
      if (youtubeUrls.length > 0) {
        youtubeUrls.forEach((url) => {
          payload.append("yt_link_lesson", url);
        });
      }
    }
    if (course?.youtube_urls?.length > 0) {
      course.youtube_urls.forEach((url) => {
        if (url) payload.append("yt_link_course", String(url));
      });
    }


    if (repoFiles?.length > 0) {
      repoFiles.forEach((file) => {
        if (file?.id) {
          payload.append("lesson_file_id", file.id);
        }
      });
    }

    createLessonsPostRef.current = {
      course,
      teacher_id,
      lesson_count: createLessonCount,
      course_id: course.course_id,
    };

    return new Promise((resolve, reject) => {
      createLessonsPostRef.current.promiseResolve = resolve;
      createLessonsPostRef.current.promiseReject = reject;

      dispatch(resetcreateLessonsStatus());
      setAwaitingCreateLessonsNav(true);
      if (isSkipForNow) {
        setSkipForNow(true);
      }
      dispatch(createLessons(course.course_id, payload, token));
    });
  };

  useEffect(() => {
    if (!awaitingCreateLessonsNav) return;
    if (createLessonsState?.isLoading) return;

    const snap = createLessonsPostRef.current;

    if (createLessonsState?.success) {
      createLessonCount > 1 ?
        toast.success(`${createLessonCount} Lessons created successfully.`, {
          position: "top-right",
        }) : toast.success(`${createLessonCount} Lesson created successfully.`, {
          position: "top-right",
        })

      setLessonsRefreshKey((k) => k + 1);
      dispatch(resetcreateLessonsStatus());
      setAwaitingCreateLessonsNav(false);
      setEnableClick(false);

      // Resolve the promise with the lesson data
      if (snap?.promiseResolve) {
        snap.promiseResolve({
          data: {
            lessons: createLessonsState?.lessons,
          },
        });
      }

      // sessionStorage.removeItem("page");
      // window.dispatchEvent(new Event("page-removed"));
      if (skipForNow) {
        closeCreateLessonCountPopup();
      }
      return;
    }

    if (createLessonsState?.error) {
      toast.error(createLessonsState.error, {
        position: "top-center",
      });
      dispatch(resetcreateLessonsStatus());
      setAwaitingCreateLessonsNav(false);

      // Reject the promise with the error
      if (snap?.promiseReject) {
        snap.promiseReject(new Error(createLessonsState.error));
      }
    }
  }, [
    awaitingCreateLessonsNav,
    createLessonsState?.isLoading,
    createLessonsState?.success,
    createLessonsState?.error,
    createLessonsState?.message,
    dispatch,
    navigate,
  ]);

  useEffect(() => {
    localStorage.removeItem("assignmentanalyticsdetails");
  }, []);


  const [formErrors, setFormErrors] = useState({
    students: "",
  });
  const validateOnInvite = () => {
    let studentsError = "";
    if (students.length === 0) {
      studentsError = "Please enter atleast one student email";
    }
    const regxIsValidEmail = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    for (let i = 0; i < students.length; i++) {
      if (!regxIsValidEmail.test(students[i].value)) {
        studentsError = "Please enter a valid email";
        break;
      }
    }

    if (studentsError) {
      setFormErrors({
        students: studentsError,
      });
      return false;
    }
    return true;
  };

  const onInvite = async () => {
    setLoading(true);

    if (!course?.course_id) {
      toast.error("Course not found");
      toggleinvite();
      setLoading(false);
      return;
    }
    const price = Number(course?.price || 0);
    const discountPrice = Number(course?.discount_price || 0);

    const INTERNAL_DOMAINS = ["@webarcitech.com", "@arcotgroup.com", "@arcitech.ai"];
    const isInternalEmail = (email = "") =>
      INTERNAL_DOMAINS.some((domain) => email.trim().toLowerCase().endsWith(domain));
    const externalEmails = students
      .map((student) => (typeof student === "string" ? student : student?.value))
      .filter((email) => !isInternalEmail(email));

    if ((price > 0 || discountPrice > 0) && externalEmails.length > 0) {
      toast.error(
        "You cannot invite students to a paid course. Students can enroll by purchasing the course.",
      );
      toggleinvite();
      setLoading(false);
      return;
    }
    await api
      .post(
        `courses/encrypt-course-id/?teacher_id=${teacher_id}`,
        {
          course: course?.course_id,
          emails: students.map((student) => student),
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
          },
        },
      )
      .then((res) => {
        toast.success("Invitation sent successfully", {
          position: "top-center",
        });
        setinvitationSuccessfull(!invitationSuccessfull);
        setInputValue("");
        setLoading(false);
        setStudents([]);
        return res?.data?.encrypted_id;
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
          err?.response?.data?.error ||
          "Something went wrong!",
          {
            position: "top-center",
          },
        );
        setLoading(false);
        return null;
      });
    setLoading(false);
    toggleinvite();
  };

  const [students, setStudents] = useState([]);

  const handleInputChange = (e) => {
    e.preventDefault();
    setInputValue(e.target.value);
  };
  const validateEmail = (email) => {
    return /\S+@\S+\.\S+/.test(email);
  };
  // Shared by Enter key and Add button so both validate identically
  const addInputEmails = () => {
    if (!inputValue.trim()) return; // Nothing to add, same as the disabled Add button
    const inputValues = inputValue.trim().split(/[\s,]+/); // Split by spaces or commas
    inputValues.forEach((value) => {
      processInputVal(value.trim());
    });
    setInputValue(""); // Clear the input field after processing
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      addInputEmails();
    }
  };

  const handlePaste = (event) => {
    event.preventDefault();
    let pastedText = event.clipboardData.getData("text");
    let emailArray = pastedText
      .split(/,|\s+/)
      .filter((email) => email.trim() !== "");
    emailArray.forEach((email) => processInputVal(email.trim()));
  };

  const processInputVal = (newVal) => {
    if (newVal && validateEmail(newVal) && !students.includes(newVal)) {
      setStudents((oldValues) => [...oldValues, newVal?.toLowerCase()?.trim()]);
      setFormErrors({
        ...formErrors,
        students: "",
      });
    } else if (!validateEmail(newVal)) {
      setFormErrors({
        ...formErrors,
        students: "Please enter a valid email",
      });
    } else if (students.includes(newVal)) {
      setFormErrors({
        ...formErrors,
        students: "Email already added",
      });
    }
  };
  const handleAddStudent = (e) => {
    e.preventDefault();
    addInputEmails();
  };
  const handleKeyPress = (e) => {
    const { name, value } = e.target;
    let error = "";
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    if (!emailRegex.test(value)) {
      error = "Please enter a valid email";
    }
    setFormErrors({
      ...formErrors,
      [name]: error,
    });
    if (formErrors.students !== "") {
      return;
    }

    if (e.key === "Enter" && inputValue.trim() !== "") {
      e.preventDefault();
      const newStudent = {
        id: Date.now(), // Use a unique identifier (e.g., timestamp) as the ID
        value: inputValue?.toLowerCase()?.trim(),
      };
      setStudents([...students, newStudent]);
      setInputValue("");
    }
  };

  const handleDeleteClick = (selStudent) => {
    setStudents((students) =>
      students.filter((student) => student !== selStudent),
    );
  };
  const getShareLink = ({ platform, course, baseURL }) => {
    let shareUrl = "";
    baseURL = `${baseURL}`; // Append /view to the baseURL

    const courseDescription =
      course?.description?.length > 100
        ? `${course?.description?.substring(0, 100)}...`
        : course?.description;

    const data = `Hi! You're invited to enroll in the new course, ${course?.name} by ${course?.title} ${course?.teacher}. Check it out here:`;

    switch (platform) {
      case "facebook":
        shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
          baseURL,
        )}&quote=${encodeURIComponent(data)}`;
        break;
      case "whatsapp":
        shareUrl = `https://api.whatsapp.com/send?text=${encodeURIComponent(
          data,
        )} ${encodeURIComponent(baseURL)}`;
        break;
      case "twitter":
        shareUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(
          data,
        )} ${encodeURIComponent(baseURL)}`;
        break;
      case "instagram":
        shareUrl = `https://www.instagram.com/?url=${encodeURIComponent(
          baseURL,
        )}`;
        break;
      case "share":
        shareUrl = baseURL;
        break;
      default:
        shareUrl = baseURL;
        return;
    }

    return shareUrl;
  };
  const getPlatform = {
    FACEBOOK: "facebook",
    WHATSAPP: "whatsapp",
    TWITTER: "twitter",
    INSTAGRAM: "instagram",
    SHARE: "share",
  };
  const [sharelink, setSharelink] = useState("");
  const getURL = `${shareUrl}/course/${course?.course_id}/view`;
  const [linkBaseUrl, setLinkBaseUrl] = useState(getURL);
  const [encryptCourseId, setEncryptCourseId] = useState("");

  const onShare = async (platform, isOpenNewWindow = true) => {
    setLoading(true);

    if (!course?.course_id) {
      toast.error("Course not found");
      toggleinvite();
      setLoading(false);
      return;
    }

    setLoading(false);
    if (isOpenNewWindow) {
      toggleDropdown();
    }

    const getShareableLink = getShareLink({
      platform: platform,
      course,
      baseURL: getURL,
    });
    setLinkBaseUrl(getURL);
    setSharelink(getShareableLink);
    if (isOpenNewWindow) {
      window.open(getShareableLink, "_blank");
    }
  };
  const onClickCopy = () => {
    toggleDropdown();
    navigator.clipboard.writeText(linkBaseUrl);
    toast.success("Copied to clipboard", {
      position: "top-center",
    });
  };
  const onClickCopyInvite = () => {
    const redirectPath = `course/${course.course_id}/view`;

    const fullUrl = `${shareUrl}${shareUrl.endsWith("/") ? "" : "/"}${redirectPath}`;
    try {
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard
          .writeText(fullUrl)
          .then(() => {
            toast.success("Copied to clipboard", {
              position: "top-center",
            });
          })
          .catch((error) => {
            toast.error("Failed to copy text", {
              position: "top-center",
            });
          });
      } else {
        document.execCommand("copy");
        toast.success("Copied to clipboard", {
          position: "top-center",
        });
      }
    } catch (error) {
      toast.error("Failed to copy text", {
        position: "top-center",
      });
    }
  };

  const refetchCourse = () => {
    if (!token) return;
    api
      .get(
        `courses/get-course/${id ??
        location.state?.course_id ??
        location.state?.course?.course_id}/`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
          },
        },
      )
      .then((response) => {
        if (response.status === 200 && response?.data) {
          const courseData = response.data.data;
          setCourse(courseData);

          const courseId = courseData?.course_id;
          const teacherIdFromResp = courseData?.teacher_id;

          if (courseId) {
            dispatch(getCourseTeachers(courseId, token));
            dispatch(getActivityLogs(courseId, token, 1));
          }

          if (teacherIdFromResp && courseId) {
            api
              .get(
                `courses/teacher/enroll-course-requests/?course_id=${courseId}&status=3&teacher_id=${teacherIdFromResp}`,
                {
                  headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: `Token ${token}`,
                  },
                },
              )
              .catch(() => { });

            api
              .get(
                `courses/teacher/enroll-course-requests/?course_id=${courseId}&status=1,4,5&teacher_id=${teacherIdFromResp}`,
                {
                  headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: `Token ${token}`,
                  },
                },
              )
              .catch(() => { });
          }
        }
      })
      .catch(() => { });
  };

  useEffect(() => {
    if (token) {
      refetchCourse();
      AOS.init({
        duration: 500,
      });
    }
  }, [id]);

  const [descriptionOpen, setDescriptionOpen] = useState(false);
  const [showViewMore, setShowViewMore] = useState(false);
  const paragraphRef = useRef(null);

  const descriptionToggle = () => {
    setDescriptionOpen(!descriptionOpen);
  };

  useEffect(() => {
    const descriptionLength = course?.description?.length || 0;

    if (paragraphRef.current) {
      const lineHeight = parseFloat(
        window.getComputedStyle(paragraphRef.current).lineHeight,
      );
      const height = paragraphRef.current.clientHeight;
      const lineCount = height / lineHeight;

      setShowViewMore(lineCount > 5 || descriptionLength > 1000);
    }
  }, [course?.description]);

  useEffect(() => {
    if (showDropdown || showinvite || showCreateLessonCountPopup) {
      changeScrollPopup("hidden", "view-course-details-share-form");
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showDropdown, showinvite, showCreateLessonCountPopup]);
  const containerRef = useRef(null); // Ref for the container
  const lastElementRef = useRef(null); // Ref for the last element
  const [activeTabCourse, setactiveTabCourse] = useState("lessons");
  useEffect(() => {
    if (lastElementRef.current) {
      containerRef.current?.scrollIntoView({ behavior: "smooth" });
    }
  }, [students]);

  const deleteLesson = useSelector((state) => state.deleteLesson);
  const deleteAssignment = useSelector((state) => state.deleteAssignment);

  useEffect(() => {
    if (deleteLesson?.success) {
      toast.success("Lesson has been deleted succesfully.");
      dispatch(resetdeleteLesson());
    } else if (deleteLesson?.error?.length) {
      toast.error("Something went wrong.");
      dispatch(resetdeleteLesson());
    }
    return () => {
      dispatch(resetdeleteLesson());
    };
  }, [deleteLesson]);

  useEffect(() => {
    if (deleteAssignment?.success) {
      toast.success("Assignment has been deleted succesfully.");
      dispatch(resetdeleteAssignment());
    } else if (deleteAssignment?.error?.length) {
      toast.error("Something went wrong.");
      dispatch(resetdeleteAssignment());
    }
    return () => {
      dispatch(resetdeleteAssignment());
    };
  }, [deleteAssignment]);
  const updateCourseArchiveStatus = (isArchived) => {
    setCourse((prev) => ({
      ...prev,
      is_archived: isArchived,
    }));
  };

  return (
    <>
      <div className="dashboard" id="viewcourseDetails-section">
        <div className="view-course-Details-wrapper">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-12 col-md-12">
                <div
                  className="view-course-Details-back-btn-folder"
                  onClick={() => {
                    sessionStorage.removeItem("page");
                    if (location.state?.from === "notification") {
                      // const targetPath = "/notification-page";
                      // navigate(targetPath);
                      navigate(-1)
                    } else if (location?.state?.from) {
                      navigate(location?.state?.from)
                    } else if (backToCourses) {
                      navigate("/dashboard/courses");
                    } else {
                      navigate("/");
                    }
                  }}
                >
                  <i class="fa-solid fa-chevron-left"></i> Back
                </div>
                <CourseDetailsHeader
                  course={course}
                  onEditCourseClick={onEditCourseClick}
                  toggleinvite={toggleinvite}
                  totalLessons={totalLessons}
                  totalAssignments={totalAssignments}
                  totalStudent={totalStudent}
                  setactiveTabCourse={setactiveTabCourse}
                  onInvitedStudents={onInvitedStudents}
                  refetchCourse={refetchCourse}
                  updateCourseArchiveStatus={updateCourseArchiveStatus}
                  // disableCourseFilesBtn={isLowerSchoolEnabled}
                />

                <CourseTab
                  course={course}
                  teacher_id={teacher_id}
                  totalLessons={totalLessons}
                  onCreateLesson={openCreateLessonCountPopup}
                  onNavigateNewLesson={onNavigateNewLesson}
                  lessonsRefreshKey={lessonsRefreshKey}
                  refetchCourse={refetchCourse}
                  setTotalStudent={setTotalStudent}
                  setTotalLessons={setTotalLessons}
                  setTotalAssignments={setTotalAssignments}
                  addlessonBtn={(() => {
                    if (
                      activeTabCourse === "lessons" &&
                      course?.my_role !== "viewer" &&
                      globalState.role !== "SuperAdmin" &&
                      totalLessons !== 0
                    ) {
                      return (
                        <div type="button" className="add-lesson-btn ">
                          <button
                            type="button"
                            onClick={openCreateLessonCountPopup}
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              justifyContent: "center",
                              gap: "0.5rem",
                            }}
                          >
                            <i className="fa-solid fa-plus"></i>
                            Add Lesson
                          </button>
                        </div>
                      );
                    }
                    if (
                      activeTabCourse === "students" &&
                      course?.my_role !== "viewer"
                    ) {
                      return (
                        <div type="button" className="add-lesson-btn">
                          <button
                            type="button"
                            onClick={toggleinvite}
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              justifyContent: "center",
                              gap: "0.5rem",
                            }}
                          >
                            <i className="fa-solid fa-user-plus"></i>
                            <span>Invite Students</span>
                          </button>
                        </div>
                      );
                    }
                    if (
                      activeTabCourse === "studentsRequest" ||
                      activeTabCourse === "activityLog"
                    ) {
                      return null;
                    }
                    if (activeTabCourse === "manageTeachers") {
                      return (
                        <AddTeachers
                          course={course}
                          token={token}
                          changeScrollPopupProp={changeScrollPopup}
                          onTransferComplete={refetchCourse}
                        />
                      );
                    }
                    return null;
                  })()}
                  activeTabCourse={activeTabCourse}
                  setactiveTabCourse={setactiveTabCourse}
                  invitationSuccessfull={invitationSuccessfull}
                />
              </div>
            </div>
          </div>
        </div>

        {showinvite && (
          <div className="view-course-details-share-form">
            <div
              ref={modalRef}
              className="view-course-details-share-folder desktop-invite-modal"
            >
              <h2>Invite Students</h2>
              <div className="view-course-details-inner-wrapper">
                <p>Add Student Email ID</p>
                <div className="copy-link-or-path-folder invite-course-wrapper invite-student-popup-folder">
                  <div className="Subjects-you-teach">
                    <form onSubmit={(e) => e.preventDefault()} className="w-full">
                    <input
                      type="text"
                      style={
                        formErrors.students ? { border: "1px solid red" } : null
                      }
                      name="students"
                      placeholder="example@example.com"
                      value={inputValue}
                      autoComplete="off"
                      onChange={handleInputChange}
                      onKeyDown={handleKeyDown}
                      onPaste={handlePaste}
                    />
                    </form>
                    {
                      <button
                        className="add-student-btn"
                        disabled={inputValue.trim() === ""}
                        onClick={handleAddStudent}
                        type="button"
                      >
                        Add
                      </button>
                    }
                  </div>

                  <p
                    style={{
                      color: "red",
                      fontSize: "0.8rem",
                      textAlign: "left",
                      margin: "0.5rem 0",
                    }}
                  >
                    {formErrors.students}
                  </p>
                  {students.length > 0 && (
                    <div
                      ref={containerRef}
                      className="Subjects-you-teach-feilds-folder"
                    >
                      {students.map((student, index) => (
                        <div
                          key={`${student}-${index}`}
                          ref={
                            index === students.length - 1
                              ? lastElementRef
                              : null
                          }
                          className="Subjects-you-teach-feilds invite-student-feilds-folder"
                        >
                          <p>{student}</p>
                          <a
                            className="subject-delete-btn"
                            onClick={() => handleDeleteClick(student)}
                          >
                            <i className="fa-solid fa-xmark"></i>
                          </a>
                        </div>
                      ))}
                    </div>
                  )}
                  {loading ? (
                    <div className="view-course-details-loader" />
                  ) : (
                    <button
                      className="invite-student-btn"
                      disabled={loading || students.length <= 0}
                      onClick={onInvite}
                      type="button"
                    >
                      Invite
                    </button>
                  )}
                </div>
                <i
                  onClick={toggleinvite}
                  data-aos="zoom-in"
                  className="fa-solid fa-xmark shocial-cross-btn invite-student-close-btn"
                ></i>
                <p className="or-title">Or</p>
                {linkBaseUrl !== "" && (
                  <div className="copy-link-or-path-folder">
                    <div
                      className="invite-copy-link"
                      onClick={onClickCopyInvite}
                    >
                      <span>
                        <i class="fa-solid fa-link"></i>
                      </span>
                      <span> Copy link</span>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div ref={mobileModalRef} className="mobile-invite-modal">
              <div className="flex items-center justify-between mb-4">
                <h2 className="text-[16px] font-semibold m-0">
                  Invite Students
                </h2>
                <button
                  type="button"
                  onClick={toggleinvite}
                  className="bg-transparent border-none cursor-pointer text-[18px] text-[#000]"
                >
                  <i className="fa-solid fa-xmark"></i>
                </button>
              </div>

              <form onSubmit={(e) => e.preventDefault()} className="w-full">
              <input
                type="text"
                style={{
                  width: "100%",
                  padding: "10px 14px",
                  borderRadius: "8px",
                  border: formErrors.students
                    ? "1px solid red"
                    : "1px solid #e0e0e0",
                  fontSize: "14px",
                  marginBottom: "8px",
                  boxSizing: "border-box",
                }}
                name="students"
                placeholder="Add email to invite"
                value={inputValue}
                autoComplete="off"
                onChange={handleInputChange}
                onKeyDown={handleKeyDown}
                onPaste={handlePaste}
              />
              </form>
              {formErrors.students && (
                <p
                  style={{
                    color: "red",
                    fontSize: "0.8rem",
                    margin: "0 0 8px 0",
                  }}
                >
                  {formErrors.students}
                </p>
              )}

              {students.length > 0 && (
                <div
                  ref={containerRef}
                  className="Subjects-you-teach-feilds-folder bg-[rgb(232, 232, 232)]"
                >
                  {students.map((student, index) => (
                    <div
                      key={`${student}-${index}`}
                      ref={
                        index === students.length - 1 ? lastElementRef : null
                      }
                      className="Subjects-you-teach-feilds invite-student-feilds-folder"
                    >
                      <p className="text-[#000]">{student}</p>
                      <a
                        className="subject-delete-btn"
                        onClick={() => handleDeleteClick(student)}
                      >
                        <i className="fa-solid fa-xmark"></i>
                      </a>
                    </div>
                  ))}
                </div>
              )}

              {linkBaseUrl !== "" && (
                <div
                  className="invite-copy-link mt-3"
                  onClick={onClickCopyInvite}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    color: "#0068ff",
                    cursor: "pointer",
                    fontSize: "14px",
                  }}
                >
                  <i className="fa-solid fa-link"></i>
                  <span>Copy link</span>
                </div>
              )}

              <div className="flex gap-3 mt-4">
                <button
                  type="button"
                  className="flex-1 py-2 rounded-lg text-[14px] cursor-pointer"
                  style={{
                    border: "1px solid #e0e0e0",
                    background: "white",
                    color: "#000",
                  }}
                  onClick={toggleinvite}
                >
                  Cancel
                </button>
                {loading ? (
                  <div className="flex-1 flex justify-center">
                    <div className="view-course-details-loader" />
                  </div>
                ) : (
                  <button
                    type="button"
                    className="flex-1 py-2 rounded-lg text-white text-[14px] cursor-pointer flex items-center justify-center gap-2"
                    style={{ background: "#0068ff", border: "none" }}
                    disabled={loading || students.length <= 0}
                    onClick={onInvite}
                  >
                    Invite <i className="fa-solid fa-user-plus"></i>
                  </button>
                )}
              </div>
            </div>
          </div>
        )}

        <AddLessonModal
          open={showCreateLessonCountPopup}
          onClose={closeCreateLessonCountPopup}
          course={course}
          teacher_id={teacher_id}
          incrementCreateLessonCount={incrementCreateLessonCount}
          decrementCreateLessonCount={decrementCreateLessonCount}
          createLessonCount={createLessonCount}
          setCreateLessonCount={setCreateLessonCount}
          createLessonStep={createLessonStep}
          setCreateLessonStep={setCreateLessonStep}
          confirmCreateLessonNavigation={confirmCreateLessonNavigation}
          awaitingCreateLessonsNav={awaitingCreateLessonsNav}
          setAwaitingCreateLessonsNav={setAwaitingCreateLessonsNav}
          lessonsRefreshKey={lessonsRefreshKey}
          setLessonsRefreshKey={setLessonsRefreshKey}
          enableClick={enableClick}
          setEnableClick={setEnableClick}
          links={links}
          setLinks={setLinks}
          makeLinkRow={makeLinkRow}
          lowerSchool = {isLowerSchoolEnabled}
        />
      </div>
      {!adminRole && (
        <FloatingAIButton
          onClick={() => {
            const agentData = [
              {
                key: course?.name || "Course",
                value: String(course?.course_id || ""),
              },
            ];

            dispatch(setAgentData(agentData));
            if (course?.course_id) {
              dispatch(setInitialProjectId(String(course?.course_id)));
            }
            dispatch(setDrawerState(!chatDrawerState.isOpen));
            dispatch(setIsWebAllowed(true));
            dispatch(setQueryMetaData(null));
          }}
        />
      )}
    </>
  );
};

export default TeacherViewCourseDetails;